import Loader from "components/loader";
import { lazy, Suspense } from "react";

const LazyView = lazy(() => import("./view"));

const Component: React.FC<any> = (props) => (
  <Suspense fallback={<Loader />}>
    <LazyView {...props} />
  </Suspense>
);

export default Component;
